import { FC } from 'react'
import * as styles from 'components/features/external/PublicSpendingTrend/LineChartPoints.styl'
import { Point } from 'components/features/external/PublicSpendingTrend/helpers'

type LineChartPointsProps = {
  points: Point[]
}

export const LineChartPoints: FC<LineChartPointsProps> = ({ points }) => {

  return (
    <>
      { points.map((point, index) => (
        <circle
          className={ styles.lineChartPoints }
          key={ index }
          cx={ point[0] }
          cy={ point[1] }
        />
      )) }
    </>
  )
}
